/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * Wraps a given onClick callback to run only if the attached element is not disabled, and to send
 * Google Analytics events if run.
 *
 * For Google Analytics functionality to work properly, the window must have an object called `analytics`
 * attached to it that has a `sendEvent` method that takes an Analytics event category, action, and label
 * as arguments.
 */
const ifClickable = (
  onClick: any,
  analyticsEventLabel?: any,
  analyticsEventCategory?: string,
  analyticsEventAction?: string
): any => {
  if (!onClick) {
    return;
  }

  return (event: React.ChangeEvent<HTMLInputElement>) => {
    const currentTarget = event.currentTarget;

    if (currentTarget) {
      const isDisabled = currentTarget.disabled || currentTarget.hasAttribute('disabled');

      if (isDisabled) {
        event.preventDefault();
        return;
      }
    }
    if (analyticsEventLabel && (window as any).analytics) {
      (window as any).analytics.sendEvent(
        analyticsEventCategory || 'button',
        analyticsEventAction || 'click',
        analyticsEventLabel
      );
    }
    onClick(event);
  };
};

export { ifClickable };
